export default __webpack_public_path__ + "static/media/img7.5b36cccc.png";